
import { tokens } from "../../theme/theme";
import { Typography, Card, CardContent, Grid, Button, useTheme, Box } from "@mui/material";

// icons 
import CommitOutlinedIcon from '@mui/icons-material/CommitOutlined';
import LooksOutlinedIcon from '@mui/icons-material/LooksOutlined';
import { useTranslation } from "react-i18next";


// import '../../components/boxstyles.css';



import BusinessIcon from '@mui/icons-material/Business';
import GavelIcon from '@mui/icons-material/Gavel';
import TuneIcon from '@mui/icons-material/Tune';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import useUserPermissions from "../../pages/commonfunctions/useUserPermissions";

const sections = [
    { icon: <BusinessIcon />, label: 'Organization', color: '#D1FADF' },
    { icon: <GavelIcon />, label: 'Taxes & Compliance', color: '#E0EAFF' },
    { icon: <TuneIcon />, label: 'Preferences', color: '#FFEFD6' },
    { icon: <ShoppingCartIcon />, label: 'Sales', color: '#D1FADF' },
    { icon: <ShoppingBagIcon />, label: 'Purchases', color: '#D1FADF' },
];

const HumanResourceMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();
    const userPermissions = useUserPermissions();

    const callback = () => {
        handleBackDashboard();
    };

    return (
        <Box >
            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center"  >
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">{t('hr_menu.hr_header')} </Typography>
                    </Box>
                </CardContent>
            </Card>


            <Box p={2}>
                <Grid container spacing={2} justifyContent="start"   >
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <LooksOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.employee')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ViewEmployeeListPage")}>View</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.project')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ViewProjectList")}>View</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.shift_master')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ShiftMaster")}>Update</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.shift_roster')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ShiftRoaster")}>Update</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.shift_emp_assignment')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ShiftEmployeeAssignment")}>Update</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.attendance_managment')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("AttendanceOverview")}>View</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.Add_overtime')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("AddOvertime")}>Add</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.Overtime_approval')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("OvertimeApprovalDashboard")}>Update</Button>
                        </Card>
                    </Grid>


                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.leave_request')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("LeaveRequestForm")}>View</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.Leave_approval')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("LeaveApprovalDashboard")}>View</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.leave_balance')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("LeaveBalance")}>View</Button>
                        </Card>
                    </Grid>




                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.salary_components')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ViewSalaryComponents")}>View</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.salary_slip')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ViewSalarySlip")}>View</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.holidays')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ViewHolidays")}>View</Button>
                        </Card>
                    </Grid>

<Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.ShiftRosterUI')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Shift Roaster UI")}>View</Button>
                        </Card>
                    </Grid>



<Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.OnDutyReimpursement')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("OnDuty Reimpursement")}>View</Button>
                        </Card>
                    </Grid>


<Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <CommitOutlinedIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>{t('hr_menu.OnDutyApproval')}</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("OnDuty Approval")}>View</Button>
                        </Card>
                    </Grid>

                    {/* Repeat the Grid item for each production entry */}
                    {/* You can customize the style and content for each card */}
                </Grid>
            </Box>
        </Box>

    )
}
export default HumanResourceMenu;